module.exports = __webpack_public_path__ + "img/laptop.8ad5ea6f.png";